import { __rest } from "tslib";
import * as React from 'react';
import warning from '../_util/warning';
import Base from './Base';
const Link = React.forwardRef((_a, ref) => {
    var { ellipsis, rel } = _a, restProps = __rest(_a, ["ellipsis", "rel"]);
    warning(typeof ellipsis !== 'object', 'Typography.Link', '`ellipsis` only supports boolean value.');
    const mergedProps = Object.assign(Object.assign({}, restProps), { rel: rel === undefined && restProps.target === '_blank' ? 'noopener noreferrer' : rel });
    // @ts-ignore
    delete mergedProps.navigate;
    return React.createElement(Base, Object.assign({}, mergedProps, { ref: ref, ellipsis: !!ellipsis, component: "a" }));
});
export default Link;
